import { CollectionsConfig } from './collections.abstract.config';

export const collectionsConfig: CollectionsConfig = {
  privileges: {
    job: {
      teamMembers: {
        view: 'web:jobs-team-members-view',
        edit: 'web:jobs-team-members-edit',
      },
    },
    hiringManager: 'hiring-manager',
  },
};
